
import { defineComponent } from 'vue'

import PlanDetailMixin from '~/mixins/planDetailMixin'

export default defineComponent({
  name: 'UpgradePlan',
  mixins: [PlanDetailMixin],
  props: {
    showConfirmDialogProp: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      updating: false,
      message:
        'Upgrading will give your team access to features like Autofix, Code Formatters and more. You can downgrade anytime you want just as easily.'
    }
  },
  async fetch() {
    await this.fetchContext()
  },
  computed: {
    showConfirmDialog: {
      get(): boolean {
        return this.showConfirmDialogProp
      },
      set(value: boolean) {
        this.$emit('update:showConfirmDialogProp', value)
      }
    }
  },
  methods: {
    async upgrade(close: () => void): Promise<void> {
      const upgradeTo = this.availableUpgradePlans.planSlug
      this.updating = true
      try {
        await this.changeSubscriptionPlan({
          id: this.owner.id,
          planSlug: upgradeTo
        })
        if (close) {
          close()
        } else {
          this.showConfirmDialog = false
        }
      } catch (e) {
        this.$toast.danger('Something went wrong while upgrading your plan')
      } finally {
        this.$emit('refetch')
        await this.refetchData()
        this.updating = false
      }
    },
    showUpgradeConfirmModal() {
      this.showConfirmDialog = true
    },
    close() {
      this.showConfirmDialog = false
    }
  }
})
